<ion-app>
	<app-toast />
	<app-alert />
	<app-debugging-modal />
	<app-loading />

	@let market = placeBetModalService.market$ | async;
	@let selectedRunner = placeBetModalService.selectedRunner$ | async;
	@if (market && selectedRunner && !whiteLabelService.isV3Skin()) {
		<app-place-bet-modal
			[market]="market"
			[selectedRunner]="selectedRunner"
			[additionalStakeValidators]="(placeBetModalService.additionalStakeValidators$ | async) ?? []" />
	}

	<ion-router-outlet />
</ion-app>
